import OBase from './OBase';

import * as Geometry from '../geometry';

export default class Radians extends OBase {
  update () {
    let valTree = this.getFloatInput('Degrees');
    let pOutput = this.getGenericObjectOutput('Radians');

    var outTree = new Geometry.DataTree();

    const deg2rad = 1.0 / 180.0 * Math.PI;

    for (let i = 0; i < valTree.branches.length; i++) {
      for (let j = 0; j < valTree.branches[i].length; j++) {
        let val = valTree.branches[i][j];
        let nval = val * deg2rad;
        outTree.add(nval, valTree.paths[i]);
      }
    }

    pOutput.value = outTree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/Radians.js